import {Inject, NgModule} from "@angular/core";
import {GruppemedlemDatatjeneste} from "./GruppemedlemDatatjeneste";
import {GruppeDatatjeneste} from "./GruppeDatatjeneste";
import {AksjeeierDatatjeneste} from "felles-ng2/tjenester/datalager/AksjeeierDatatjeneste";
import {AksjeklasseDatatjeneste} from "felles-ng2/tjenester/datalager/AksjeklasseDatatjeneste";
import {BrukerDatatjeneste} from "felles-ng2/tjenester/datalager/BrukerDatatjeneste";
import {InvitasjonerDatatjeneste} from "felles-ng2/tjenester/datalager/InvitasjonerDatatjeneste";
import {MøteDatatjeneste} from "felles-ng2/tjenester/datalager/MøteDatatjeneste";
import {KommentarDatatjeneste} from "felles-ng2/tjenester/datalager/KommentarDatatjeneste";
import {SakDatatjeneste} from "felles-ng2/tjenester/datalager/SakDatatjeneste";
import {SaksdokumentDatatjeneste} from "felles-ng2/tjenester/datalager/SaksdokumentDatatjeneste";
import {OppgaveDatatjeneste} from "felles-ng2/tjenester/datalager/OppgaveDatatjeneste";
import {BeslutningDatatjeneste} from "felles-ng2/tjenester/datalager/BeslutningDatatjeneste";
import {AvstemningDatatjeneste} from "felles-ng2/tjenester/datalager/AvstemningDatatjeneste";
import {FavorittDatatjeneste} from "felles-ng2/tjenester/datalager/FavorittDatatjeneste";
import {ArkivDatatjeneste} from "felles-ng2/tjenester/datalager/ArkivDatatjeneste";
import {SkjermingDatatjeneste} from "felles-ng2/tjenester/datalager/SkjermingDatatjeneste";
import {DokumentSigneringDatatjeneste} from "felles-ng2/tjenester/datalager/DokumentSigneringDatatjeneste";
import {MøteMedAggregaterDatatjeneste} from "felles-ng2/tjenester/datalager/MøteMedAggregaterDatatjeneste";
import {SpørreundersøkelseDatatjeneste} from "felles-ng2/tjenester/datalager/SpørreundersøkelseDatatjeneste";
import {Miljø, MILJØ} from "felles-ng2/tjenester/Appkonfigurasjon";
import {enableElfProdMode} from "@ngneat/elf";
import {AvstemningsstatusDatatjeneste} from "felles-ng2/tjenester/datalager/AvstemningsstatusDatatjeneste";
import {MøtedeltakereDatatjeneste} from "felles-ng2/tjenester/datalager/MøtedeltakereDatatjeneste";
import {ProtokollførtMøtedeltakereDatatjeneste} from "felles-ng2/tjenester/datalager/ProtokollførtMøtedeltakereDatatjeneste";
import {ProtokollDatatjeneste} from "felles-ng2/tjenester/datalager/ProtokollDatatjeneste";

@NgModule({
    providers: [
        AksjeeierDatatjeneste,
        AksjeklasseDatatjeneste,
        BrukerDatatjeneste,
        GruppeDatatjeneste,
        GruppemedlemDatatjeneste,
        InvitasjonerDatatjeneste,
        KommentarDatatjeneste,
        MøteDatatjeneste,
        MøteMedAggregaterDatatjeneste,
        MøtedeltakereDatatjeneste,
        ProtokollDatatjeneste,
        ProtokollførtMøtedeltakereDatatjeneste,
        SakDatatjeneste,
        SaksdokumentDatatjeneste,
        OppgaveDatatjeneste,
        BeslutningDatatjeneste,
        AvstemningDatatjeneste,
        FavorittDatatjeneste,
        ArkivDatatjeneste,
        SkjermingDatatjeneste,
        DokumentSigneringDatatjeneste,
        SpørreundersøkelseDatatjeneste,
        AvstemningsstatusDatatjeneste
    ]
})
export class DatalagerModul {

    constructor(gruppemedlemDatatjeneste: GruppemedlemDatatjeneste,
                gruppeDatatjeneste: GruppeDatatjeneste,
                beslutningDatatjeneste: BeslutningDatatjeneste,
                avstemningDatatjeneste: AvstemningDatatjeneste,
                møteDatatjeneste: MøteDatatjeneste,
                sakDatatjeneste: SakDatatjeneste,
                oppgaveDatatjeneste: OppgaveDatatjeneste,
                saksdokumentDatatjeneste: SaksdokumentDatatjeneste,
                @Inject(MILJØ) miljø: Miljø) {
        if (miljø == Miljø.prod) enableElfProdMode();

        //sørger for å sette avhengigheter som ikke kan injiseres pga sirkularitet i avhengighetene
        gruppemedlemDatatjeneste.setDatatjenester(gruppeDatatjeneste);
        sakDatatjeneste.setDatatjenester(møteDatatjeneste);
        beslutningDatatjeneste.setDatatjenester(sakDatatjeneste, oppgaveDatatjeneste);
        avstemningDatatjeneste.setDatatjenester(sakDatatjeneste, møteDatatjeneste);
        oppgaveDatatjeneste.setDatatjenester(sakDatatjeneste);
        saksdokumentDatatjeneste.setDatatjenester(sakDatatjeneste);
    }
}
